import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { GET_DATA_SOURCE, UPDATE_DATA_SOURCE } from "../../../../queries";

const SettingsProfile = (props: any) => {
    // Source with all HASURA fields
    const [source, setSource] = useState<any>(null);

    // Individual HASURA Fields
    const [selected_stac_address, setSelected_stac_address] = useState<any>(null);
    const [selected_collection_id, setSelected_collection_id] = useState<any>(null);
    const [selected_process_catalog_id, setSelected_process_catalog_id] = useState<any>(null);
    const [selected_min_date, setSelected_min_date] = useState<any>(null);
    const [selected_max_date, setSelected_max_date] = useState<any>(null);
    const [selected_is_public, setSelected_is_public] = useState<any>(null);
    const [selected_is_ext, setSelected_is_ext] = useState<any>(null);
    const [selected_template, setSelected_template] = useState<any>(null);
    const [selected_capabilities, setSelected_capabilities] = useState<any>(null);
    const [selected_citation, setSelected_citation] = useState<any>(null);
    const [selected_min_zoom_level, setSelected_min_zoom_level] = useState<any>(null);
    const [selected_max_zoom_level, setSelected_max_zoom_level] = useState<any>(null);
    const [selected_metadata, setSelected_metadata] = useState<any>(null);
    const [selected_data_source_type_id, setSelected_data_source_type_id] = useState<any>(null);
    const [selected_public_data_catalog_id, setSelected_public_data_catalog_id] = useState<any>(null);
    const [selected_stac_query_prefix, setSelected_stac_query_prefix] = useState<any>(null);
    const [selected_date_display_resolution, setSelected_date_display_resolution] = useState<any>(null);
    const [selected_title, setSelected_title] = useState<any>(null);
    const [selected_expr, setSelected_expr] = useState<any>(null);
    const [selected_jq, setSelected_jq] = useState<any>(null);
    const [selected_color_map, setSelected_color_map] = useState<any>(null);
    const [selected_color_ramp, setSelected_color_ramp] = useState<any>(null);
    const [selected_global_min, setSelected_global_min] = useState<any>(null);
    const [selected_global_max, setSelected_global_max] = useState<any>(null);
    const [selected_tile_server, setSelected_tile_server] = useState<any>(null);

    useEffect(() => {
        (async function fetchData() {
            await load();
        })();
    }, [props.sourceId]);

    const load = async () => {
        loadSource(props.client,props.sourceId)
    }

    const loadSource = (client:any,sourceId:number) => {
        var data = {
            id: sourceId
        };
        client.query({
            query: GET_DATA_SOURCE,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log('GET_DATA_SOURCE result', result);
            setSource(result.data.syncarto_app_data_source[0]);
            setSelected_stac_address(result.data.syncarto_app_data_source[0].stac_address);
            setSelected_collection_id(result.data.syncarto_app_data_source[0].collection_id);
            setSelected_process_catalog_id(result.data.syncarto_app_data_source[0].process_catalog_id);
            setSelected_min_date(result.data.syncarto_app_data_source[0].min_date);
            setSelected_max_date(result.data.syncarto_app_data_source[0].max_date);
            setSelected_is_public(result.data.syncarto_app_data_source[0].is_public);
            setSelected_is_ext(result.data.syncarto_app_data_source[0].is_ext);
            setSelected_template(result.data.syncarto_app_data_source[0].template);
            setSelected_capabilities(result.data.syncarto_app_data_source[0].capabilities);
            setSelected_citation(result.data.syncarto_app_data_source[0].citation);
            setSelected_min_zoom_level(result.data.syncarto_app_data_source[0].min_zoom_level);
            setSelected_max_zoom_level(result.data.syncarto_app_data_source[0].max_zoom_level);
            setSelected_metadata(result.data.syncarto_app_data_source[0].metadata);
            setSelected_title(result.data.syncarto_app_data_source[0].title);
            setSelected_data_source_type_id(parseInt(result.data.syncarto_app_data_source[0].data_source_type_id));
            setSelected_public_data_catalog_id(parseInt(result.data.syncarto_app_data_source[0].public_data_catalog_id));
            setSelected_stac_query_prefix(result.data.syncarto_app_data_source[0].stac_query_prefix);
            setSelected_date_display_resolution(result.data.syncarto_app_data_source[0].date_display_resolution);
            setSelected_expr(result.data.syncarto_app_data_source[0].expr);
            setSelected_jq(result.data.syncarto_app_data_source[0].jq);
            setSelected_color_map(result.data.syncarto_app_data_source[0].color_map);
            setSelected_color_ramp(result.data.syncarto_app_data_source[0].color_ramp);
            setSelected_global_min(result.data.syncarto_app_data_source[0].global_min);
            setSelected_global_max(result.data.syncarto_app_data_source[0].global_max);
            setSelected_tile_server(result.data.syncarto_app_data_source[0].tile_server);
        });
    }  
    
    const handleChange_stac_address = (e:any) => {
        setSelected_stac_address(e.target.value);
    }     
    
    const handleChange_collection_id = (e:any) => {
        setSelected_collection_id(e.target.value);
    }    

    const handleChange_process_catalog_id = (e:any) => {
        setSelected_process_catalog_id(e.target.value);
    }     
       
    const handleChange_min_date = (e:any) => {
        setSelected_min_date(e.target.value);
    }     
           
    const handleChange_max_date = (e:any) => {
        setSelected_max_date(e.target.value);
    }     
               
    const handleChange_is_public = (e:any) => {
        setSelected_is_public(e.target.value);
    }     
                   
    const handleChange_is_ext = (e:any) => {
        setSelected_is_ext(e.target.value);
    }     
                       
    const handleChange_template = (e:any) => {
        setSelected_template(e.target.value);
    }     
                           
    const handleChange_capabilities = (e:any) => {
        setSelected_capabilities(e.target.value);
    }     
                               
    const handleChange_citation = (e:any) => {
        setSelected_citation(e.target.value);
    }     
                                    
    const handleChange_min_zoom_level = (e:any) => {
        setSelected_min_zoom_level(e.target.value);
    }     
                                         
    const handleChange_max_zoom_level = (e:any) => {
        setSelected_max_zoom_level(e.target.value);
    }     
                                   
    const handleChange_metadata = (e:any) => {
        setSelected_metadata(e.target.value);
    }     
    
    const handleChange_data_source_type_id = (e:any) => {
        setSelected_data_source_type_id(parseInt(e.target.value));
    }    
    
    const handleChange_public_data_catalog_id = (e:any) => {
        setSelected_public_data_catalog_id(parseInt(e.target.value));
    }    
    
    const handleChange_stac_query_prefix = (e:any) => {
        setSelected_stac_query_prefix(e.target.value);
    }    
    
    const handleChange_date_display_resolution = (e:any) => {
        setSelected_date_display_resolution(e.target.value);
    }    

    const handleChange_title = (e:any) => {
        setSelected_title(e.target.value);
    }
    
    const handleChange_expr = (e:any) => {
        setSelected_expr(e.target.value);
    }    

    const handleChange_jq = (e:any) => {
        setSelected_jq(e.target.value);
    }    

    const handleChange_color_map = (e:any) => {
        setSelected_color_map(e.target.value);
    }    

    const handleChange_color_ramp = (e:any) => {
        setSelected_color_ramp(e.target.value);
    }    

    const handleChange_global_min = (e:any) => {
        setSelected_global_min(e.target.value);
    }    

    const handleChange_global_max = (e:any) => {
        setSelected_global_max(e.target.value);
    }    

    const handleChange_tile_server = (e:any) => {
        setSelected_tile_server(e.target.value);
    }    


    const updateSource = async (e:any) => {
        let updatedSource:any = [
                    {"stac_address":selected_stac_address},
                    {"title":selected_title},
                    {"collection_id":selected_collection_id},
                    {"data_source_type_id":selected_data_source_type_id},
                    {"public_data_catalog_id":selected_public_data_catalog_id},
                    {"process_catalog_id":selected_process_catalog_id}, 
                    {"min_date":selected_min_date},
                    {"max_date":selected_max_date},
                    {"is_public":selected_is_public},
                    {"is_ext":selected_is_ext},
                    {"template":selected_template},
                    {"capabilities":selected_capabilities},
                    {"citation":selected_citation},
                    {"min_zoom_level":selected_min_zoom_level},
                    {"max_zoom_level":selected_max_zoom_level},
                    {"metadata":selected_metadata},
                    {"stac_query_prefix":selected_stac_query_prefix},
                    {"date_display_resolution":selected_date_display_resolution},
                    {"expr":selected_expr},
                    {"jq":selected_jq},
                    {"color_map":selected_color_map},
                    {"color_ramp":selected_color_ramp},
                    {"global_min":selected_global_min},
                    {"global_max":selected_global_max},
                    {"tile_server":selected_tile_server}
        ];
        console.log(updatedSource)

        props.client.mutate({
            mutation: UPDATE_DATA_SOURCE,
            variables: {
                id: source.id,
                stac_address: selected_stac_address,
                title: selected_title,
                collection_id: selected_collection_id,
                data_source_type_id: selected_data_source_type_id,
                public_data_catalog_id: selected_public_data_catalog_id,
                process_catalog_id: selected_process_catalog_id, 
                min_date: selected_min_date,
                max_date: selected_max_date,
                is_public: selected_is_public,
                is_ext: selected_is_ext,
                template: selected_template,
                capabilities: selected_capabilities,
                citation: selected_citation,
                min_zoom_level: selected_min_zoom_level,
                max_zoom_level: selected_max_zoom_level,
                metadata: selected_metadata,
                stac_query_prefix: selected_stac_query_prefix,
                date_display_resolution: selected_date_display_resolution,
                expr: selected_expr,
				jq: selected_jq,
				color_map: selected_color_map,
				color_ramp: selected_color_ramp,
				global_min: selected_global_min,
				global_max: selected_global_max,
				tile_server: selected_tile_server,
            },
            optimisticResponse: null,
        })
        setTimeout(() => {
            props.shouldRefreshSources(); 
        }, 500);
    }

    
    if(!source) { 
        return (
            <div>loading...</div>
        );
    }
    /* SCHEMA FOR HASURA data_source TABLE, 10/29/21 
    FORM ELEMENT	        FIELDNAME	            DATA TYPE
        <NOT IN FORM>	        id	                    integer
    X    dropdown	            data_source_type_id	    integer               // All are presently null but see HASURA data_source_type table for options
    X    text input	            stac_address	        text
    X    <NOT IN FORM>	        collection_id	        text
    X    dropdown	            public_data_catalog_id	integer
    X    integer input	        process_catalog_id	    integer
        <NOT EDITABLE>	        org_id	                uuid
    X    date picker	        min_date	            date
    X    date picker	        max_date	            date
    X    text input	            title	                text
        <NOT IN FORM>	        extent	                geometry
    X    dropdown	            is_public	            boolean
    X    dropdown	            is_ext	                boolean
    X    text input	            template	            character varying
    X    text input	            capabilities	        character varying
    X    text input	            citation	            character varying
    X    text input	            metadata	            character varying
    X    integer input	        min_zoom_level	        integer
    X    integer input	        max_zoom_level	        integer
    X    dropdown <NOT IN FORM>	stac_query_prefix	    text                   eo:constellation | collection
    X    dropdown <NOT IN FORM>	date_display_resolution	character varying      day | year
    */
    console.log(props.formOptions)
    return (
        <>
            <h4>Update Catalog</h4>  
            <Form style={{marginTop: "10px", padding:"1em", overflowY:"scroll"}}>
                <Form.Group as={Row} controlId="form_stac_title">
                    <Form.Label column sm="3">
                        Title                    
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_title} value={selected_title ? selected_title : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_stac_address">
                    <Form.Label column sm="3">
                        STAC Address
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_stac_address} value={selected_stac_address ? selected_stac_address : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_collection_id">
                    <Form.Label column sm="3">
                        Collection ID
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_collection_id} value={selected_collection_id ? selected_collection_id : '' }/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_data_source_type_id">
                    <Form.Label column sm="3">
                        Data Source Type
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_data_source_type_id}
                            value={selected_data_source_type_id ? selected_data_source_type_id : undefined}
                        >
                            {
                                props.formOptions.optionsFor_data_source_type_id.map((typeId: any) => {
                                    return (
                                        <option key={typeId.id} value={typeId.id}>{typeId.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_public_data_catalog_id">
                    <Form.Label column sm="3">
                        Public Data Catalog
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control disabled // GraphQL error: Foreign key violation. insert or update on table "data_source" violates foreign key constraint "fk_public_data_catalog_id"
                            as="select"
                            onChange={handleChange_public_data_catalog_id}
                            value={selected_public_data_catalog_id ? selected_public_data_catalog_id : undefined}
                        >
                            {
                                props.formOptions.optionsFor_public_data_catalog_id.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.catalog_description}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_process_catalog_id">
                    <Form.Label column sm="3">
                        Collection ID
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="number" onChange={handleChange_process_catalog_id} value={selected_process_catalog_id ? selected_process_catalog_id : ''}/>
                    </Col>
                </Form.Group>                
                <Form.Group as={Row} controlId="form_min_date">
                    <Form.Label column sm="3">
                        Min Date
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="date" onChange={handleChange_min_date} value={selected_min_date ? selected_min_date : undefined}/>
                    </Col>
                </Form.Group>  
                <Form.Group as={Row} controlId="form_max_date">
                    <Form.Label column sm="3">
                        Max Date
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="date" onChange={handleChange_max_date} value={selected_max_date ? selected_max_date : undefined}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_is_public">
                    <Form.Label column sm="3">
                        Is Public
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_is_public}
                            value={selected_is_public ? selected_is_public: "false"}
                        >
                            <option key={"true"} value={"true"}>{"True"}</option>
                            <option key={"false"} value={"false"}>{"False"}</option>
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_is_ext">
                    <Form.Label column sm="3">
                        Is Ext
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_is_ext}
                            value={selected_is_ext ? selected_is_ext : "false"}
                        >
                            <option key={"true"} value={"true"}>{"True"}</option>
                            <option key={"false"} value={"false"}>{"False"}</option>
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_template">
                    <Form.Label column sm="3">
                        Template
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_template} value={selected_template ? selected_template : ''}/>
                    </Col>
                </Form.Group>              
                <Form.Group as={Row} controlId="form_capabilities">
                    <Form.Label column sm="3">
                        Capabilities
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_capabilities} value={selected_capabilities ? selected_capabilities : ''}/>
                    </Col>
                </Form.Group>                 
                <Form.Group as={Row} controlId="form_citation">
                    <Form.Label column sm="3">
                        Citation
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_citation} value={selected_citation ? selected_citation : ''}/>
                    </Col>
                </Form.Group>                
                <Form.Group as={Row} controlId="form_metadata">
                    <Form.Label column sm="3">
                        Metadata
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_metadata} value={selected_metadata ? selected_metadata : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_min_zoom_level">
                    <Form.Label column sm="3">
                        Min Zoom Level
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="number" onChange={handleChange_min_zoom_level} value={selected_min_zoom_level ? selected_min_zoom_level : ''}/>
                    </Col>
                </Form.Group> 
                <Form.Group as={Row} controlId="form_max_zoom_level">
                    <Form.Label column sm="3">
                        Max Zoom Level
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="number" onChange={handleChange_max_zoom_level} value={selected_max_zoom_level ? selected_max_zoom_level : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_stac_query_prefix">
                    <Form.Label column sm="3">
                        STAC Query Prefix
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_stac_query_prefix}
                            value={selected_stac_query_prefix ? selected_stac_query_prefix : undefined}
                        >
                            {
                                props.formOptions.optionsFor_stac_query_prefix.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>                
                <Form.Group as={Row} controlId="form_date_display_resolution">
                    <Form.Label column sm="3">
                        Date Display Resolution
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_date_display_resolution}
                            value={selected_date_display_resolution ? selected_date_display_resolution : ''}
                        >
                            {
                                props.formOptions.optionsFor_date_display_resolution.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_global_min">
                    <Form.Label column sm="3">
                        Global Min
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="number" onChange={handleChange_global_min} value={selected_global_min ? selected_global_min : ''}/>
                    </Col>
                </Form.Group> 
                <Form.Group as={Row} controlId="form_global_max">
                    <Form.Label column sm="3">
                        Global Max
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="number" onChange={handleChange_global_max} value={selected_global_max ? selected_global_max : ''}/>
                    </Col>
                </Form.Group> 
                <Form.Group as={Row} controlId="form_expr">
                    <Form.Label column sm="3">
                        Expression
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_expr} value={selected_expr ? selected_expr : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_jq">
                    <Form.Label column sm="3">
                        JQ
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_jq} value={selected_jq ? selected_jq : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_color_map">
                    <Form.Label column sm="3">
                        Color Map
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_color_map} value={selected_color_map ? selected_color_map : ''}/>
                    </Col>
                </Form.Group>                
                <Form.Group as={Row} controlId="form_color_ramp">
                    <Form.Label column sm="3">
                        Color Ramp
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_color_ramp} value={selected_color_ramp ? selected_color_ramp : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_tile_server">
                    <Form.Label column sm="3">
                        Tile Server
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_tile_server} value={selected_tile_server ? selected_tile_server : ''}/>
                    </Col>
                </Form.Group>
                <div style={{paddingTop: "7px"}}>
                    <Button variant="warning" onClick={updateSource}>Update Catalog</Button>
                </div>
            </Form>
        </>
    );
}

export default SettingsProfile;